export const LINK_TYPE_CATEGORY = 'category' as const;
export const LINK_TYPE_NON_CATEGORY = 'non_category' as const;
export const NAVIGATION_ITEM_TYPE_LIVESTREAM = 'livestream' as const;
